import { render, staticRenderFns } from "./ValentineIcon.vue?vue&type=template&id=93c5032e"
import script from "./ValentineIcon.vue?vue&type=script&lang=js"
export * from "./ValentineIcon.vue?vue&type=script&lang=js"
import style0 from "./ValentineIcon.vue?vue&type=style&index=0&id=93c5032e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports